import { render, staticRenderFns } from "./BrandManageTypography.vue?vue&type=template&id=50073620&"
import script from "./BrandManageTypography.vue?vue&type=script&lang=ts&"
export * from "./BrandManageTypography.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports